import { render } from "./FinishPage.vue?vue&type=template&id=f2916a12&scoped=true"
import script from "./FinishPage.vue?vue&type=script&lang=js"
export * from "./FinishPage.vue?vue&type=script&lang=js"

import "./FinishPage.vue?vue&type=style&index=0&id=f2916a12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2916a12"]])

export default __exports__